
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Models
import {AppCommonDiagnosticCategory} from "@/models/app/common/diagnostic-category";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import CoachNavigationVue from "@/components/coach/navigation.vue";
import CoachPlayersProfileNavigationVue from "@/components/coach/players/profile/navigation.vue";
import CoachPlayersProfileDiagnosticsFilterIndexVue from "@/views/app/coach/players/profile/diagnostics/filter/index.vue";
import CoachPlayersProfileDiagnosticsListIndexVue from "@/views/app/coach/players/profile/diagnostics/list/index.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    CoachNavigationVue,
    CoachPlayersProfileNavigationVue,
    CoachPlayersProfileDiagnosticsFilterIndexVue,
    CoachPlayersProfileDiagnosticsListIndexVue
  },
})
export default class CoachPlayersProfileDiagnosticsIndexVue extends Vue {
  isLoading: boolean | null = false;

  diagnosticCategories: Array<AppCommonDiagnosticCategory> = [];

  $refs!: {
    CoachPlayersProfileDiagnosticsListIndexVue: any;
  };

  getDiagnosticsByFilter(formData: any): void {
    this.$refs.CoachPlayersProfileDiagnosticsListIndexVue.getDiagnostics(formData);
  }

  async getDiagnosticCategories(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/common/utility/diagnostic-categories`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.diagnosticCategories = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getDiagnosticCategories();
  }
}
